import React from "react"
import { Hidden } from "@material-ui/core"
import ContentContainer from "components/ContentContainer"
import EnvIndicator from "components/EnvIndicator"
import SupportSettingsToggler from "components/SupportSettingsToggler"
import Notifications from "../../Notifications"
import { ILayoutProps } from "../types"
import DefaultLayoutDesktop from "./DefaultLayoutDesktop"
import DefaultLayoutMobile from "./DefaultLayoutMobile"
import { StyledFloatingWrapper } from "./style"

export function DefaultLayout({
  appUtilityBar,
  component: Component,
  appBarComponent,
  isTableLayout,
  matchProps,
}: ILayoutProps) {
  const content = (
    <ContentContainer isTableLayout={isTableLayout}>
      <Component {...matchProps} />
    </ContentContainer>
  )
  return (
    <>
      <Hidden xsDown={true}>
        <DefaultLayoutDesktop appUtilityBar={appUtilityBar}> {content}</DefaultLayoutDesktop>
      </Hidden>
      <Hidden smUp={true}>
        <DefaultLayoutMobile appBarComponent={appBarComponent}>{content}</DefaultLayoutMobile>
      </Hidden>
      <Notifications />
      <StyledFloatingWrapper>
        <EnvIndicator />
        <SupportSettingsToggler />
      </StyledFloatingWrapper>
    </>
  )
}

export default DefaultLayout
